export default function () {
    let source = document.querySelector('#BeforeBodyEndsContainer > iframe');
    let container = document.querySelector('.map-wrapper');
    if (!source || !container) return;

    let iframe = document.createElement('iframe');
    iframe.dataset.src = source.src;
    iframe.width = '578';
    iframe.height = '338';
    iframe.title = 'Lokalizacja na mapie';
    iframe.classList.add('lazyload');
    iframe.style.border = '0';

    container.appendChild(iframe);
}